// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StyledActionsWrap, StyledActionButton } from './ProductOfMonthTableActionsStyles';
import { EditIcon, TrashIcon } from '@/icons';
import { COLORS } from '@/theme';

// Models
import { IProduct } from '@/models/products.model';

type TProductOfMonthTableActions = {
  record: IProduct;
  handleEditClick: (banner: IProduct) => void;
  setForDelete: (banner: IProduct) => void;
};

const ProductOfMonthTableActions = ({ handleEditClick, setForDelete, record }: TProductOfMonthTableActions) => {
  const { t } = useTranslation(['banners']);

  const handleDelete = () => setForDelete(record);
  const handleEdit = () => handleEditClick(record);

  return (
    <StyledActionsWrap>
      <StyledActionButton $color={COLORS.PALE_YELLOW} onClick={handleEdit}>
        <EditIcon />
        {t('banners_list_edit')}
      </StyledActionButton>
      <StyledActionButton $color={COLORS.RED} onClick={handleDelete}>
        <TrashIcon />
      </StyledActionButton>
    </StyledActionsWrap>
  );
};

export default ProductOfMonthTableActions;
